import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__nav" };
const _hoisted_4 = { class: "data-item__topic" };
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__meta" };
const _hoisted_7 = { class: "data-item__facts" };
const _hoisted_8 = { class: "data-item__actions" };
const _hoisted_9 = { class: "data-item__content" };
const _hoisted_10 = { class: "data-item__section" };
const _hoisted_11 = { class: "data-properties data-properties--stacked" };
const _hoisted_12 = { class: "data-properties__title data-properties__title--bold" };
const _hoisted_13 = { class: "data-properties__property" };
const _hoisted_14 = { class: "data-properties__label" };
const _hoisted_15 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_16 = { class: "data-properties__details" };
const _hoisted_17 = { class: "data-item__section" };
const _hoisted_18 = { class: "data-properties data-properties--stacked" };
const _hoisted_19 = { class: "data-properties__title data-properties__title--bold" };
const _hoisted_20 = { class: "data-properties__property" };
const _hoisted_21 = { class: "data-properties__label" };
const _hoisted_22 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_23 = { class: "data-properties__property" };
const _hoisted_24 = { class: "data-properties__label" };
const _hoisted_25 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_26 = { class: "data-properties__details" };
const _hoisted_27 = { class: "data-item__section" };
const _hoisted_28 = { class: "data-properties data-properties--stacked" };
const _hoisted_29 = { class: "data-properties__title data-properties__title--bold" };
const _hoisted_30 = { class: "data-properties__property" };
const _hoisted_31 = { class: "data-properties__label" };
const _hoisted_32 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_33 = { class: "data-properties__property" };
const _hoisted_34 = { class: "data-properties__label" };
const _hoisted_35 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_36 = ["title"];
const _hoisted_37 = { class: "data-properties__details" };
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import exportProfileRepository from "../services/ShopExportProfileRepository";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import DeleteShopExportProfile from "../commands/DeleteShopExportProfile";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import ExecuteShopExportProfile from "../commands/ExecuteShopExportProfile";
import DuplicateShopExportProfile from "../commands/DuplicateShopExportProfile";
import KeyValues from "@astina/paloma-common-ui/src/components/KeyValues.vue";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportProfileDetailView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const emit = __emit;
        const profile = ref(null);
        const executeProfile = ref(null);
        const executeProfileClean = ref(null);
        const duplicateProfile = ref(null);
        const deleteProfile = ref(null);
        const reportSearchRequest = ref({ filters: [], query: null });
        onMounted(() => {
            loadProfile();
        });
        watch(() => route.params, loadProfile);
        function loadProfile() {
            const id = RouterUtils.singleParam(route, 'id');
            exportProfileRepository
                .get(id)
                .then(profileParam => {
                profile.value = profileParam;
                reportSearchRequest.value.filters = [{
                        attribute: 'process',
                        values: [`export_${profile.value.id}`]
                    }];
                executeProfile.value = new ExecuteShopExportProfile(profileParam.id);
                executeProfileClean.value = new ExecuteShopExportProfile(profileParam.id, 'REGULAR_CLEAN');
                duplicateProfile.value = new DuplicateShopExportProfile(profileParam.id);
                deleteProfile.value = new DeleteShopExportProfile(profileParam.id);
            })
                .catch(closeView);
        }
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        function formatSftpTransportSettings(settings) {
            let formatted = `${settings.user}@${settings.host}:${settings.port} `;
            if (settings.directory) {
                formatted += (settings.directory.endsWith('/') ? '' : '/');
            }
            else {
                formatted += '~/';
            }
            formatted += settings.fileNameTemplate || '';
            return formatted;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-left" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    (profile.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('export_profile')), 1),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(profile.value.name), 1),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('created_by'),
                                        value: profile.value.createdBy
                                    }, null, 8, ["label", "value"]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (profile.value._meta?.scheduleHumanized)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('export_profile.status_' + profile.value.status),
                                            value: profile.value._meta.scheduleHumanized,
                                            variant: profile.value.status === 'active' ? 'success' : 'danger'
                                        }, null, 8, ["label", "value", "variant"]))
                                        : _createCommentVNode("", true),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (profile.value._meta?.formatLabel)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 1,
                                            label: _ctx.$t('export_profile.format'),
                                            value: profile.value._meta?.formatLabel
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (profile.value._meta?.transportLabel)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 2,
                                            label: _ctx.$t('export_profile.transfer'),
                                            value: profile.value._meta?.transportLabel
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    (!profile.value.managedByIntegration)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (duplicateProfile.value)
                                                ? (_openBlock(), _createBlock(CommandButton, {
                                                    key: 0,
                                                    command: duplicateProfile.value,
                                                    label: "",
                                                    title: _ctx.$t('duplicate'),
                                                    classes: ['button', 'button--icon', 'button--outline']
                                                }, null, 8, ["command", "title"]))
                                                : _createCommentVNode("", true),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            _createVNode(_component_router_link, {
                                                to: { name: 'integration_export_edit', params: { id: profile.value.id } },
                                                class: "button button--icon"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(Icon, { name: "pencil" })
                                                ]),
                                                _: 1
                                            }, 8, ["to"]),
                                            _cache[10] || (_cache[10] = _createTextVNode()),
                                            (deleteProfile.value)
                                                ? (_openBlock(), _createBlock(CommandButton, {
                                                    key: 1,
                                                    command: deleteProfile.value,
                                                    onSuccess: _cache[3] || (_cache[3] = ($event) => (closeView())),
                                                    label: "",
                                                    classes: ['button', 'button--icon', 'button--danger']
                                                }, null, 8, ["command"]))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !profile.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[32] || (_cache[32] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    (profile.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("section", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('export_profile.source')), 1),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('export_profile.source_type')), 1),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(profile.value._meta?.sourceLabel), 1),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createVNode(KeyValues, {
                                                properties: profile.value.sourceSettings
                                            }, null, 8, ["properties"])
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            _createElementVNode("section", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t('export_profile.target')), 1),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('export_profile.format')), 1),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(profile.value._meta?.formatLabel), 1)
                                    ]),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('export_profile.transfer')), 1),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(profile.value._meta?.transportLabel), 1),
                                        _cache[20] || (_cache[20] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_26, [
                                            (profile.value.transport === 'http')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(profile.value.transportSettings.method) + " " + _toDisplayString(profile.value.transportSettings.uri), 1)
                                                ], 64))
                                                : (profile.value.transport.indexOf('sftp') === 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(formatSftpTransportSettings(profile.value.transportSettings)), 1)
                                                    ], 64))
                                                    : (_openBlock(), _createBlock(KeyValues, {
                                                        key: 2,
                                                        properties: profile.value.transportSettings
                                                    }, null, 8, ["properties"]))
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            _createElementVNode("section", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t('export_profile.execution')), 1),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('export_profile.status')), 1),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('export_profile.status_' + profile.value.status)), 1),
                                        _cache[24] || (_cache[24] = _createTextVNode()),
                                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "data-properties__details" }, null, -1))
                                    ]),
                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('export_profile.schedule')), 1),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("span", {
                                                title: profile.value.schedule
                                            }, _toDisplayString(profile.value._meta?.scheduleHumanized), 9, _hoisted_36)
                                        ]),
                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_37, [
                                            (executeProfile.value)
                                                ? (_openBlock(), _createBlock(CommandButton, {
                                                    key: 0,
                                                    command: executeProfile.value,
                                                    label: _ctx.$t('export_profile.execute_now'),
                                                    classes: ['button', 'button--link'],
                                                    style: { "margin-right": ".5rem" }
                                                }, null, 8, ["command", "label"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
